import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import { Box } from 'grommet';

import HighlightedSentences from 'app/components/HighlightedSentences';

import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
const scrollIntoViewOptions = { behavior: 'instant', block: 'start' };

class Paragraph extends React.Component {
  render() {
    const { AppState, path, content } = this.props;
    return _.chain(content)
      .split('\n')
      .map((paragraph, index) => {
        const isNewSelection =
          !AppState.bookmarkingSelectionContent ||
          !content.includes(AppState.bookmarkingSelectionContent);
        return (
          <ScrollIntoViewIfNeeded
            key={index}
            options={scrollIntoViewOptions}
            active={_.isEqual(path, AppState.selectedSectionItem)}
          >
            <Box
              key={index}
              direction="column"
              flex="grow"
              onClick={() => {
                AppState.isUserBookmarking &&
                  AppState.setMenuBar('BOOKMARKING_MENU');
                const isBookmarking =
                  AppState.isBookmarkingMenuBar || AppState.isUserAnnotating;
                if (isNewSelection && isBookmarking) {
                  AppState.newBookmarkingSelection({ path, content: path });
                }
              }}
            >
              <HighlightedSentences
                {...this.props}
                path={path}
                content={paragraph}
              />
            </Box>
          </ScrollIntoViewIfNeeded>
        );
      })
      .value();
  }
}

Paragraph.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * paragraph(s)
   */
  content: PropTypes.string,
};
Paragraph.defaultProps = {
  content: " ",
};

const Component = inject('AppState')(observer(Paragraph));
Component.displayName = 'Paragraph';
export const ParagraphComponent = Paragraph;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Paragraph.js